import React, { useRef, useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Backdrop,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import inputValidation from "../../../utils/inputValidation";
import { api } from "../../../redux/api";
import { treeActions } from "../../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep } from "lodash";
import { store } from "../../../redux/store";

export default function RenameSelectedTemplate(props) {
  const dispatch = useDispatch();
  const { toggle } = props;
  const { t } = useTranslation();
  const { account, user } = useSelector((state) => state.queryParams);
  const parentScreen = useContext(ParentScreenCtx);
  const { leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentScreen = useSelector(state => state.treeData.currentScreen)
  const sourceWorkflowName = leftTree.tree.body.selectedNode.workflowGroup;
  const selectedNode = useSelector(state => state.treeData[parentScreen].leftTree.tree.body.selectedNode);
  const sourceTemplateName = selectedNode?.title;
  const error = useRef(null);
  const [valid, setValid] = useState(true);
  const [input, setInput] = useState(sourceTemplateName);
  const [isUserSpace, setIsUserSpace] = useState(false);
  const [isServer, setIsServer] = useState(false);
  const [checkboxDisabled, setCheckboxDisabled] = useState({userspace: false, server: false});
  const [errorMsg, setErrorMsg] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const errorMessage = t("WRN_FILE_ALREADY_EXISTS_");
  const [ibRenameDependency, setIbRenameDependency] = useState({});
  const [workflowRenameDependency, setWorkflowRenameDependency] = useState({});
  const [isLoadingDependencies, setIsLoadingDependencies] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const selectedOutboundTemplate = useSelector(state => state.treeData.outbound.leftTree.tree.body.selectedNode);
  const selectedWorkflow = useSelector(state => state.treeData.workflow.leftTree.tree.body.selectedNode);
  const [showTemplateTypes, setShowTemplateTypes] = useState([]);

  const handleOkClick = (overwrite) => {
    setLoading(true)
    let dispatchType = currentScreen === 'outbound' ? 'renameOutboundTemplate' : currentScreen === 'inbound' ? 'updateTemplateName' : 'renameWorkflowTemplate';
    let dispatchTree = currentScreen === 'outbound' ? 'getOutboundTemplateList' : currentScreen === 'inbound' ? 'getInboundTemplateList' : 'getWorkflows'
    if (validateInput()) {
      let newTemplateName = input;
      if (true) {
        dispatch(
          api.endpoints[dispatchType].initiate({
            account,
            workflowGroupName:sourceWorkflowName,
            currentName: sourceTemplateName,
            newName: input,
            is_userspace: isUserSpace,
            is_server: isServer,
            is_inbound: parentScreen === 'inbound',
            is_overwrite: overwrite
          }, {forceRefetch :true})
        ).then((response) => {
          if (response.error) {
            error.current.textContent =
              response?.message || response?.data?.message || t("BOX_MSG_GENERAL_ERROR");
            return;
          }
          if (response.data.current_state === "SUCCESS") {
              dispatch(newTemplateActions.setShowAlert(true));
              dispatch(newTemplateActions.setAlertMessage(response.data.message));
              dispatch(
              treeActions.setLeftTreeContextActionValue({
                screen: parentScreen,
                data:{
                  name: newTemplateName.toLowerCase(),
                  workflowGroup: sourceWorkflowName,
                }
              })
            );
            dispatch(
              api.endpoints[dispatchTree].initiate(
                { account },
                { subscribe: false, forceRefetch: true }
              )
            ).then(() => {
              // Wait for tree refresh to complete, then force select the renamed template
              if (currentScreen === "inbound" || currentScreen === "outbound") {
              dispatch(
                treeActions.setForceTemplate({
                  template: newTemplateName.toLowerCase(),
                  workflowGroup: sourceWorkflowName,
                  screen: parentScreen,
                  forceSelect: true,
                })
              );
            }

            if(currentScreen === 'inbound'){
              selectedOutboundTemplate?.workflowGroup === sourceWorkflowName && dispatch(api.endpoints.getOutboundTemplate.initiate({
                account,
                workflowGroupName: sourceWorkflowName,
                templateName: selectedOutboundTemplate?.title
              }, {forceRefetch: true}))
              
              // Get current workflow rightTree selectedNode before API call and update after fetch
              if (selectedWorkflow?.workflowGroup === sourceWorkflowName) {
                const state = store.getState();
                const workflowRightTree = state.treeData?.workflow?.rightTree;
                const workflowCurrentTab = 'body';
                const currentWorkflowSelectedNode = workflowRightTree?.tree?.[workflowCurrentTab]?.selectedNode;
                const selectedNodeId = currentWorkflowSelectedNode?.key;
                
                dispatch(api.endpoints.getWorkflowTree.initiate({
                  account,
                  workflowGroupName: sourceWorkflowName,
                  templateName: selectedWorkflow?.title
                }, {forceRefetch: true})).then(() => {
                  // After workflow tree is fetched, find and update the selected node
                  if (selectedNodeId) {
                    const updatedState = store.getState();
                    const updatedWorkflowRightTree = updatedState.treeData?.workflow?.rightTree;
                    const updatedTranslatedData = updatedWorkflowRightTree?.tree?.[workflowCurrentTab]?.translatedData || [];
                    
                    // Find the node with matching ID in the new translatedData
                    let matchingNode = null;
                    eachDeep(cloneDeep(updatedTranslatedData), (obj) => {
                      if (obj?.key === selectedNodeId) {
                        matchingNode = obj;
                        return false; // Stop iteration
                      }
                      if (Array.isArray(obj?.children)) {
                        return obj.children;
                      }
                    });
                    // Update rightTreeSelectedNode with the new node data
                    if (matchingNode) {
                      dispatch(
                        treeActions.setRightTreeSelectedNode({
                          screen: 'workflow',
                          type: workflowCurrentTab,
                          data: {},
                        })
                      );
                      setTimeout(() => {
                        dispatch(
                          treeActions.setRightTreeSelectedNode({
                            screen: 'workflow',
                            type: workflowCurrentTab,
                            data: matchingNode,
                          })
                        );
                      })
                    }
                  }
                });
              }
            }
              toggle();
            });

          } else {
            const showModal = response.data.message.includes(t('BOX_TEM_NM_ALREADY_EXISTS__CHOOSE_ANOTHER'))
            || response.data.message.includes(t('BOX_WF_NM_ALREADY_EXISTS__CHOOSE_ANOTHER'));
            const errorAlert = showModal ? errorMessage : response.data.message;
            if (showModal) {
              setErrorMsg(errorAlert);
              setErrorModal(true);
            } else {
                error.current.textContent = response.data.message;
                setValid(false);
            }
          }
        }).catch(error => {
          error.current.textContent = error.message || error.data.message || t("BOX_MSG_GENERAL_ERROR")
        })
        .finally(() => {
          setLoading(false)
        })
      }
    } else {
      setLoading(false)
    }
  };
  const handleCancelClick = () => {
    setInput(sourceTemplateName)
    setValid(true);
    props.toggle();
  };
  const validateInput = () => {
    let inputFieldValue = input;
    if (inputValidation(inputFieldValue) === "") {
      error.current.textContent = currentScreen === 'inbound' ? t("BOX_ENTER_NEW_NM_FOR_IN_TEM") : currentScreen === 'outbound' ? t('BOX_ENTER_NEW_NM_FOR_OUT_TEM') : t('BOX_ENTER_NEW_NM_FOR_NEW_WF');
      setValid(false);
      return false;
    } else if (inputValidation(inputFieldValue) === "invalid") {
      error.current.textContent = t("BOX_TEM_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES");
      setValid(false);
      return false;
    } else if(inputFieldValue.length > 50){
      const errorMsg = t("BOX_MAX_LENGTH_FOR_NAME_IS").replace(/\{0\}/, "50");
      error.current.textContent = errorMsg;
      setValid(false);
      return false;
    }
    return true;
  };
  const handleChange = (e) => {
    setInput(e.target.value);
    error.current.textContent = "";
    setValid(true);
  }

  useEffect(() => {
    if (error?.current && (isServer || isUserSpace)) {
      error.current.textContent = ''
    }
  }, [isUserSpace, isServer]);

  useEffect(() => {
    const { location } = selectedNode;
    if (location === 'server') {
      setIsServer(true);
      setIsUserSpace(false);
      setCheckboxDisabled({ userspace: true, server: false });
    } else if (location === 'both') {
      setIsServer(true);
      setCheckboxDisabled({ userspace: false, server: false });
      setIsUserSpace(true);
    } else {
      setIsUserSpace(true);
      setCheckboxDisabled({ userspace: false, server: true });
      setIsServer(false);
    }
  }, [selectedNode]);

  useEffect(() => {
    const types = [];
    isServer && types.push('server');
    isUserSpace && types.push('userspace');
    (isServer && isUserSpace) && types.push('both');
    
    setShowTemplateTypes(types);
    
  }, [isServer, isUserSpace]);

  useEffect(() => {
    if (!props?.openModal) {
      // Reset states when modal is closed
      setIsDataLoaded(false);
      setIsLoadingDependencies(false);
      setIbRenameDependency({});
      setWorkflowRenameDependency({});
      return;
    }

    // Modal is opening, start loading dependencies
    if (currentScreen === 'inbound') {
      setIsLoadingDependencies(true);
      dispatch(api.endpoints.checkInboundTemplateDependency.initiate({
        account,
        workflowGroupName: sourceWorkflowName,
        templateName: sourceTemplateName
      }, {forceRefetch: true}))
        .then((response) => {
          setIbRenameDependency(response?.data?.data || {});
        })
        .catch((error) => {
          console.error('Error loading inbound dependency:', error);
          setIbRenameDependency({});
        })
        .finally(() => {
          setIsLoadingDependencies(false);
          setIsDataLoaded(true);
        });
    } else if (currentScreen === 'workflow') {
      setIsLoadingDependencies(true);
      dispatch(api.endpoints.checkWorkflowRenameDependency.initiate({
        account,
        workflowGroupName: sourceWorkflowName,
        workflowName: sourceTemplateName,
        user: user
      }, {forceRefetch: true}))
        .then((response) => {
          setWorkflowRenameDependency(response?.data?.data || {});
        })
        .catch((error) => {
          console.error('Error loading workflow dependency:', error);
          setWorkflowRenameDependency({});
        })
        .finally(() => {
          setIsLoadingDependencies(false);
          setIsDataLoaded(true);
        });
    } else {
      // For outbound or screens without dependency check, open immediately
      setIsDataLoaded(true);
    }
  }, [props?.openModal, currentScreen, account, sourceWorkflowName, sourceTemplateName, user, dispatch]);


  const errorModalHandler = () => {
    setErrorModal(!errorModal);
    toggle();
  };
 
  return (
    <>
      {/* Loading backdrop while fetching dependencies */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={props.openModal && isLoadingDependencies}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Only render dialog when data is loaded */}
      <Dialog open={props.openModal && isDataLoaded} fullWidth maxWidth="sm">
        <DialogTitle className="dialog-header">
          <div className="title">
            { currentScreen === 'inbound' ? t("DIAG_RENAME_INBOUND_TEMPLATE_TIT") : currentScreen === 'outbound' ?  t('DIAG_RENAME_OUTBOUND_TEMPLATE_TIT') : t('DIAG_RENAME_WORKFLOW_TIT') }
          </div>
          <div className="description">
              { currentScreen === 'inbound' ? t("DIAG_RENAME_INBOUND_TEMPLATE_DESC") : currentScreen === 'outbound' ? t('BOX_ENTER_NEW_NM_FOR_OUT_TEM') : t('BOX_ENTER_NEW_NM_FOR_NEW_WF') }
          </div>
        </DialogTitle>
        <DialogContent className="modal-content" dividers style={{width: 'unset', height: (ibRenameDependency?.totalAffected || workflowRenameDependency?.totalAffected) ? 'unset' : '130px' }}>
          <div style={{marginBottom: "1.5rem" }}>
            <span>
            {t("WIZ_RENAME_WF_GROUP_1_MESSAGE").substring(
                0,
                t("WIZ_RENAME_WF_GROUP_1_MESSAGE").indexOf(".") + 1
              )}           
            </span>
          </div>
          <div className={"default-delimiter-field"}>
            <TextField
              variant="outlined"
              size="small"
              type="text"
              autoFocus={true}
              autoComplete="off"
              label={ currentScreen === 'inbound' ? t("LBL_NEW_IN_TEM_NM") : currentScreen === 'outbound' ? t("LBL_NEW_OUT_TEM_NAME") : t('LBL_NEW_WORKFLOW_NAME') }
              error={!valid}
              value={input}
              onChange={(e) => {handleChange(e)}}
            />
          </div>
          <p className="error" ref={error}></p>
        </DialogContent>

        {(ibRenameDependency?.totalAffected > 0 || workflowRenameDependency?.totalAffected > 0) && <DialogContent className="modal-content" dividers style={{width: 'unset'}}>
        { currentScreen === 'inbound' && ibRenameDependency?.totalAffected > 0 && (
              <Box>
                <Typography sx={{ mb: 2, fontWeight: 500 }}>
                  {t("LBL_THE_FOLLOWING_TEMPLATES_WILL_BE_AFFECTED")}
                </Typography>
                <TableContainer 
                  component={Paper} 
                  sx={{ 
                    maxHeight: 300,
                    '&::-webkit-scrollbar': {
                      display: 'none',
                    },
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                  }}
                >
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>{t("LOCATION")}</TableCell>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>{t("NAME")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ibRenameDependency?.affectedOutboundTemplates
                      ?.filter(template => showTemplateTypes.includes(template?.location))
                      ?.map((template, index) => {
                        const pathArray = template?.path?.split('/');
                        const location = `${account}/${pathArray[0]}/outbound_templates`;
                        const name = pathArray[1];
                        return (
                          <TableRow key={`outbound-${index}`} hover>
                            <TableCell>{location}</TableCell>
                            <TableCell>{name}</TableCell>
                          </TableRow>
                        )
                      })}
                      {ibRenameDependency?.affectedWorkflows
                      ?.filter(workflow => showTemplateTypes.includes(workflow?.location))
                      ?.map((workflow, index) => {
                        const pathArray = workflow?.path?.split('/');
                        const location = `${account}/${pathArray[0]}/workflows`;
                        const name = pathArray[1];
                        return (
                          <TableRow key={`workflow-${index}`} hover>
                            <TableCell>{location}</TableCell>
                            <TableCell>{name}</TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            { currentScreen === 'workflow' && workflowRenameDependency?.totalAffected > 0 && (
              <Box>
                <Typography sx={{ mb: 2, fontWeight: 500 }}>
                  {t("WIZ_RENAME_WF_SAVE_DEPENDNT_MESSAGE").split('\\n')[0]}
                </Typography>
                <TableContainer 
                  component={Paper} 
                  sx={{ 
                    maxHeight: 300,
                    '&::-webkit-scrollbar': {
                      display: 'none',
                    },
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                  }}
                >
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>Location</TableCell>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: '#f5f5f5' }}>{t("NAME")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {workflowRenameDependency?.affectedParentWorkflows
                      ?.filter(workflow => showTemplateTypes.includes(workflow?.location))
                      ?.map((workflow, index) => {
                        const pathArray = workflow?.path?.split('/');
                        const location = `${account}/${pathArray[0]}`;
                        const name = pathArray[1];
                        return (
                          <TableRow key={`parent-workflow-${index}`} hover>
                            <TableCell>{location}</TableCell>
                            <TableCell>{name}</TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
        </DialogContent>}
        <DialogActions>
            <div className="flex justify-start width-100">
              <TPCheckbox
                label={t('USERSPACE')}
                checked={isUserSpace}
                disabled={checkboxDisabled.userspace}
                handleCheck={(checked) => {
                  setIsUserSpace(checked);
                }}
              />
              <TPCheckbox
                label={t('SERVER')}
                checked={isServer}
                disabled={checkboxDisabled.server}
                handleCheck={(checked) => {
                  setIsServer(checked);
                }}
              />
            </div>
          <Button size="small" variant="outlined" color="primary" disabled={!valid || loading} onClick={() =>handleOkClick("no")}>
            {loading ? <CircularProgress size={"20px"}/> :  t("FINISH")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={handleCancelClick}
          >
            {t("CANCEL")}
          </Button>
        </DialogActions>
        {/* {showError && <p className="error" ref={error}></p>} */}
      </Dialog>
       {/* Error Modal */}
       <Dialog
        open={errorModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle className="dialog-header">
          <div className="title">{t("BOX_CONFIRM")}</div>
        </DialogTitle>
        <DialogContent dividers>{errorMsg}</DialogContent>
        <DialogActions>
          <Button
            size="small"
            color="primary"
            onClick={() => {
              handleOkClick("yes")
            }}
            variant="outlined">
            {t("YES")}
          </Button>
          <Button size="small" onClick={errorModalHandler} variant={"outlined"}>
            {t("NO")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
